import "./circularProgress.css";
export const FinishedLabel = ({
  size = 70,
  fontSize = 15,
  onClick,
}: {
  size?: number;
  fontSize?: number;
  onClick?: any;
}) => {
  return (
    <div
      className=" libraryFinished "
      style={{ height: size, width: size, fontSize }}
      onClick={onClick}
    >
      Finished
    </div>
  );
};
